export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Webhooks.json?hash=c29e139e49be72bb439ac2965fa967a8";